import { createRoute, lazyRouteComponent } from '@tanstack/react-router'
import { rootRoute } from './root'
import { RouteError } from '@lunary/ui-web/screen-state'

export const readingChatRoute = createRoute({
  path: 'readings/$readingId',
  getParentRoute: () => rootRoute,
  component: lazyRouteComponent(() => import('../features/readings/chat-page'), 'ReadingChatPage'),
  errorComponent: RouteError,
})
